import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // SSR'de retry olmasın — stream kapandıktan sonra tekrar denemesin
        retry: 0,
        staleTime: 1000 * 60 * 5,
      },
    },
  });
}

// Client-side'da tek instance kullan (HMR uyumluluğu için)
let browserQueryClient: QueryClient | undefined;

function getQueryClient() {
  if (typeof window === "undefined") {
    // Server: her zaman yeni QueryClient
    return makeQueryClient();
  }
  // Client: singleton (React tree unmount/remount'a dayanıklı)
  if (!browserQueryClient) browserQueryClient = makeQueryClient();
  return browserQueryClient;
}

export function getContext() {
  return {
    queryClient: getQueryClient(),
  };
}

export function Provider({ children }: { children: ReactNode }) {
  const qc = getQueryClient();
  return <QueryClientProvider client={qc}>{children}</QueryClientProvider>;
}
